module.exports = __webpack_public_path__ + "img/slide-8.50e50aaa.jpeg";